"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkVEXLEQSEjs = require('./chunk-VEXLEQSE.js');

// src/common-components/select/index.ts
var select_default = _chunkVEXLEQSEjs.Select;



exports.select_default = select_default;
//# sourceMappingURL=chunk-TBFQWQM5.js.map